import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Department from "@/pages/Department";
import OfficeStructure from "@/pages/OfficeStructure";
import RoleOfDIC from "@/pages/RoleOfDIC";
import Schemes from "@/pages/Schemes";
import SchemeDetail from "@/pages/SchemeDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/department" element={<Department />} />
                                <Route path="/office-structure" element={<OfficeStructure />} />
                                <Route path="/role" element={<RoleOfDIC />} />
                                <Route path="/schemes" element={<Schemes />} />
                                <Route path="/schemes/:id" element={<SchemeDetail />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                            </Routes>
                        </Layout>
                        <Toaster position="top-right" richColors />
                    </BrowserRouter>
                </AuthProvider>
            </LanguageProvider>
        </div>
    );
}

export default App;
